import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return (JSON.parse(localStorage.getItem("karyna_cart")) || []).map((i) => ({ ...i, key: i.key || i.slug }));
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    localStorage.setItem("karyna_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, size = null, color = null, qty = 1) => {
    const key = [product.slug, size, color].filter(Boolean).join("__");
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => (i.key === key ? { ...i, qty: Math.min(i.qty + qty, 20) } : i));
      }
    return [...prev, { ...product, size, color, key, qty }];
    });
  };

  const setQty = (key, qty) => {
    if (qty < 1) return remove(key);
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty } : i)));
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => { setItems([]); setPromo(null); };

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.qty * i.price, 0);
  const discount = promo ? Math.round(total * promo.percent) / 100 : 0;
  const grandTotal = Math.round((total - discount) * 100) / 100;

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, total, discount, grandTotal, promo, setPromo, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}
